import { useCallback } from "react";
import { checkUserPermissions, getLocalStorageItem } from "../helper";

const usePermissions = () => {
  const getPermissions = useCallback(async (permission: string) => {
    try {
      const isPermitted = await checkUserPermissions(
        getLocalStorageItem('uid'),
        permission
      );
      
      return Boolean(isPermitted);
    } catch (error) {
      console.log('GET PERMISSIONS ERROR: ', error);
      return false;
    }
  }, []);

  const checkPermission = useCallback(async (permission: string) => {
    const isPermitted = await getPermissions(permission);
    return isPermitted;
  }, [])

  return {
    getPermissions,
    checkPermission
  };
};

export default usePermissions;
